import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Accepts an absolute http(s) URL with a dotted host (https://indusplast.com.ar/promo). Empty values pass: pair it
 * with Validators.required when the field is mandatory. Error key: `url`.
 */
export function httpUrlValidator(control: AbstractControl): ValidationErrors | null {
  const value = typeof control.value === 'string' ? control.value.trim() : control.value;
  if (!value) return null;

  try {
    const url = new URL(value);
    const isHttp = url.protocol === 'http:' || url.protocol === 'https:';
    return isHttp && url.hostname.includes('.') ? null : { url: true };
  } catch {
    return { url: true };
  }
}
